import {locale as setDayjsLocale} from 'dayjs';
import 'dayjs/locale/nb';
import 'dayjs/locale/nn';
import type {Locale} from '../../types';
import {MasterLocale} from '../../types';
import {setNumberLocale} from './formatNumber';

setDayjsLocale(MasterLocale);

export const setFormattingLocale = (locale: Locale) => {
  setDayjsLocale(locale);
  setNumberLocale(locale);
};

export * from './formatDate';
export * from './formatYear';
export * from './formatTime';
export * from './formatRelativeTime';
export * from './formatNumber';
export * from './getApiDateFormat';
